const FirebaseConfigDev = {
  apiKey: 'AIzaSyCkQjcrkLzM0JKLK5IBhzzFJh1mlhYxcBM',
  authDomain: 'karmuh-dev.firebaseapp.com',
  projectId: 'karmuh-dev',
  measurementId: 'G-0MK5W3X2Q5',
};

export default FirebaseConfigDev;
